// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__c6gAB","colMaxWidth":"Table_colMaxWidth__UbUEL"};